import React from 'react';
import ReactSpeedometer from 'react-d3-speedometer';
import { useTheme } from '@material-ui/core';


const Riskmeter = (props) => {
  const theme = useTheme();
  const {
    currentValueText = 'Risk',
      width = 140,
      height = 140,
      value = 0,
    valueTextFontSize = '16px',
      hideNeedle = false
  } = props;
  return (
    <ReactSpeedometer
        // forceRender={true}
      value={value ? value : 0}
      minValue={0}
      maxValue={100}
      width={width}
      height={height}
      customSegmentLabels={[
        {
          text: "Lowest",
          position: "OUTSIDE",
          fontSize: "10px",
        },
        {
          text: "Low",
          position: "OUTSIDE",
          fontSize: "10px",
        },
        {
          text: "Medium",
          position: "OUTSIDE",
          fontSize: "10px",
        },
        {
          text: "High",
          position: "OUTSIDE",
          fontSize: "10px",
        },
        {
          text: "Highest",
          position: "OUTSIDE",
          fontSize: "10px",
        },
      ]}
      ringWidth={30}
      needleColor={theme.palette.text.secondary}
      needleHeightRatio={hideNeedle ? 0.05 : 0.5}
      needleTransitionDuration={4000}
      needleTransition="easeElastic"
      segmentColors={['#00863B', '#03A64A', '#F2E205', '#F28705', '#D93D04']}
      currentValueText= {currentValueText} //{'${value}s User online'}
      valueTextFontSize={valueTextFontSize}
      textColor={theme.palette.text.primary}
    />
  );
};

export default Riskmeter;
